<template>
  <div ref="container" class="click-effect-container"></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ClickEffect',
  mounted() {
    const container = this.$refs.container as HTMLElement
    if (!container) return

    document.body.addEventListener('click', this.handleClick)
  },
  beforeUnmount() {
    document.body.removeEventListener('click', this.handleClick)
  },
  methods: {
    handleClick(e: MouseEvent) {
      const x = e.clientX
      const y = e.clientY
      this.createParticles(x, y)
    },
    createParticles(x: number, y: number) {
      const container = this.$refs.container as HTMLElement
      if (!container) return

      const colors = ['#ff0000', '#00ff00', '#0000ff', '#ffff00', '#00ffff']
      const particleGroup = document.createElement('div')
      particleGroup.style.cssText = `
        position: absolute;
        left: ${x}px;
        top: ${y}px;
        pointer-events: none;
      `
      container.appendChild(particleGroup)

      for (let i = 0; i < 12; i++) {
        const particle = document.createElement('div')
        const size = Math.random() * 20 + 15
        const color = colors[Math.floor(Math.random() * colors.length)]
        
        particle.style.cssText = `
          position: absolute;
          width: ${size}px;
          height: ${size}px;
          background-color: ${color};
          border-radius: 50%;
          transform: translate(-50%, -50%);
          pointer-events: none;
        `
        
        const angle = (i / 12) * Math.PI * 2
        const velocity = Math.random() * 2 + 4
        const vx = Math.cos(angle) * velocity
        const vy = Math.sin(angle) * velocity
        
        particleGroup.appendChild(particle)
        
        let frameCount = 0
        const animate = () => {
          frameCount++
          const progress = frameCount / 40
          const moveX = vx * frameCount * 1.5
          const moveY = vy * frameCount * 1.5
          const scale = 1 - progress
          
          if (progress >= 1) {
            particle.remove()
            if (particleGroup.children.length === 0) {
              particleGroup.remove()
            }
            return
          }
          
          particle.style.transform = `translate(calc(-50% + ${moveX}px), calc(-50% + ${moveY}px)) scale(${scale})`
          particle.style.opacity = (1 - progress * 0.8).toString()
          
          requestAnimationFrame(animate)
        }
        
        requestAnimationFrame(animate)
      }
    }
  }
})
</script>

<style scoped>
.click-effect-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  pointer-events: none;
  z-index: 999999;
}
</style> 